/*LIBRARY*/
import { Component } from "react";
import { connect } from "react-redux";

/*COMPONENT*/
import Modal from "../common_modal/Modal";
import CreateLayer from "../editor_sidebar/CreateLayer";
import ModalApiInput from "../editor_api/ModalApiInput";
import ImportGeojson from "../editor_upload_data/ImportGeojson";
import CreateFolder from "../editor_sidebar/CreateFolder";
import JOIN_TABLE from "../editor_search_import/JOIN_TABLE";
import NotificationProject from "../editor_trivial/NotificationProject";
import SEARCH_LAYER from "../editor_search_import/SEARCH_LAYER";
import FormFeature from "../editor_table/TableEditViaForm";

/*REDUX*/
import {
  setTabelStatus,
  setChatStatus,
  getDetailLayerByLinkWOgeojson,
} from "../../App/actions/layerActions";
import {
  removeDuplicateFeatures,
  setMapMode,
} from "../../App/actions/layerNewActions";
import { getDetailLayerById } from "../../App/actions/get_features_action";
import { set_value_layer } from "../../App/actions/layerActions";
import {
  openModal,
  setModeList,
  setLanguage,
} from "../../App/actions/authActions";
import {
  set_value_properties,
  get_detail_many_layer,
} from "../../App/actions/propertiesActions";
import { getProjectDetailByLink } from "../../App/actions/projectActions";
import { status_action } from "../../App/actions/mapActions";

/*PICTURE*/

/*FUNCTION*/

/*DATA*/
import dict from "../../Data/dict.json";

class ACTION_LAYER extends Component {
  state = {
    //modal
    modalCreateLayer: false,
    modalImportLayer: false,
    modalOverviewLayer: false,
    modalImportCsv: false,
    modalCreateFolder: false,
    modalJoinTable: false,
    modalAttachLayer: false,
    modalApiBridging: false,

    //number
    new_layer_height: 0,
    import_layer_height: 0,
    join_table_layer_height: 0,
    overview_layer_height: 0,
    import_csv_height: 0,
    new_folder_height: 0,
    modalFullscreen: false,
    modal_opsi: false,
    modalSelectMap: false,
    modalEdit: false,
    modalStatistic: false,
    modal_edit_project: false,

    //other
    tableComponent: {
      height: 0,
    },
    width: window.innerWidth,
  };

  componentDidMount() {
    if (document.getElementById("new_layer")) {
      document.getElementById("new_layer").style.height = "19px";
      document.getElementById("import_layer").style.height = "19px";
      document.getElementById("new_folder").style.height = "19px";
      document.getElementById("join_table").style.height = "19px";
    }
  }

  on_close_modal_edit_label_config = () => {
    this.props.set_value_properties({
      key: "modal_edit_label_config",
      value: false,
    });
  };

  on_close_modal_edit_layer_style = () => {
    this.props.set_value_properties({
      key: "modal_edit_layer_style",
      value: false,
    });
    this.props.set_value_properties({
      key: "is_preview_on",
      value: false,
    });
    this.props.status_action();
  };

  on_close_modal_edit_symbol_icon = () => {
    this.props.set_value_properties({
      key: "modal_edit_symbol_icon",
      value: false,
    });
    this.props.set_value_properties({
      key: "is_preview_on",
      value: false,
    });
    this.props.status_action();
  };

  toggle_link_edit = () => {
    this.props.set_value_layer({
      key: "modal_link_edit",
      value: !this.props.layer.modal_link_edit,
    });
  };

  onSetModeList = (mode) => {
    this.props.setModeList(mode);
    setTimeout(
      function () {
        this.setState({ modal_opsi: false });
      }.bind(this),
      700
    );
  };

  toggleOpsi = () => {
    this.setState({ modal_opsi: !this.state.modal_opsi });
  };

  onOpenModal = (name) => {
    this.props.openModal(name);
  };

  toggleFullscreen = () => {
    this.setState({ modalFullscreen: !this.state.modalFullscreen });
  };

  toggleAttachLayer = () => {
    this.setState({ modalAttachLayer: !this.state.modalAttachLayer });
  };

  toggleCreateLayer = () => {
    this.setState({ modalCreateLayer: !this.state.modalCreateLayer }, () => {
      if (this.state.modalCreateLayer) {
        document.getElementById("new_layer").style.height = "100%";
      } else {
        document.getElementById("new_layer").style.height = "19px";
      }
    });
  };

  toggleImportLayer = () => {
    this.setState({ modalImportLayer: !this.state.modalImportLayer }, () => {
      if (this.state.modalImportLayer) {
        document.getElementById("import_layer").style.height = "100%";
      } else {
        document.getElementById("import_layer").style.height = "19px";
      }
    });
  };

  toggleApiBridging = () => {
    this.setState({ modalApiBridging: !this.state.modalApiBridging }, () => {
      if (this.state.modalApiBridging) {
        document.getElementById("api_bridging").style.height = "100%";
      } else {
        document.getElementById("api_bridging").style.height = "19px";
      }
    });
  };

  toggleJoinTable = () => {
    this.setState({ modalJoinTable: !this.state.modalJoinTable }, () => {
      if (this.state.modalJoinTable) {
        document.getElementById("join_table").style.height = "100%";
      } else {
        document.getElementById("join_table").style.height = "19px";
      }
    });
  };

  toggleCreateFolder = () => {
    this.setState({ modalCreateFolder: !this.state.modalCreateFolder }, () => {
      if (this.state.modalCreateFolder) {
        document.getElementById("new_folder").style.height = "100%";
      } else {
        document.getElementById("new_folder").style.height = "19px";
      }
    });
  };

  handleTableComponent = (height, width) => {
    this.setState({
      tableComponent: {
        height: height,
        width: width,
      },
    });
  };

  setSelectedMap = (val) => {
    this.props.setMapMode(val);
  };

  toggleModalSelectMap = () => {
    const { modalSelectMap } = this.state;
    this.setState({
      modalStatistic: false,
      modalSelectMap: !modalSelectMap,
    });
  };

  toggleModalStatisticMode = () => {
    const { modalStatistic } = this.state;
    this.setState({
      modalStatistic: !modalStatistic,
      modalSelectMap: false,
    });
  };

  toggleEdit = (geo_project) => {
    if (geo_project?._id) {
      this.props.setProject(geo_project);
    }
    this.setState({ modalEdit: !this.state.modalEdit });
  };

  render() {
    //local storage
    const language = localStorage?.language || this.props.auth.language;

    //local state
    const {
      modalCreateLayer,
      modalImportLayer,
      modalJoinTable,
      modalCreateFolder,
      modalApiBridging,
      modalAttachLayer,
    } = this.state;

    //global props
    const { geo_project_link } = this.props.properties;
    const mode = this?.props?.mode;
    const modal_link_edit = this.props.layer.modal_link_edit;

    //content
    const modal_link_edit_content = modal_link_edit && (
      <Modal
        modalSize="large"
        isOpen={modal_link_edit}
        onClose={this.toggle_link_edit}
      >
        <div className="box-body">
          <FormFeature />
        </div>
      </Modal>
    );

    const modalAttachLayerContent = modalAttachLayer && (
      <Modal
        modalSize="medium"
        isOpen={modalAttachLayer}
        onClose={this.toggleAttachLayer}
      >
        <div className="box-body">
          <SEARCH_LAYER />
        </div>
      </Modal>
    );

    let final_content = (
      <main>
        <section
          className="inputBox background_grey_light"
          id="new_layer"
          style={{ marginTop: "5px" }}
        >
          <div
            onClick={this.toggleCreateLayer}
            style={{ display: "flex", paddingBottom: 4, cursor: "pointer" }}
            data-mapid="clickNewLayer"
          >
            <div className="noselect" style={{ flex: 1 }}>
              {dict["New Layer"][language]}
            </div>
            <div>
              <svg
                aria-hidden="true"
                focusable="false"
                data-prefix="fas"
                data-icon="caret-down"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 320 512"
                style={{
                  width: "1.25rem",
                  height: "1.25rem",
                  transition: "transform 0.5s ease 0s",
                  transform: `${
                    modalCreateLayer ? "rotate(180deg)" : "rotate(0deg)"
                  }`,
                }}
              >
                <path
                  fill="currentColor"
                  d="M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z"
                ></path>
              </svg>
            </div>
          </div>
          <CreateLayer />
        </section>

        <section className="inputBox background_grey_light" id="import_layer">
          <div
            onClick={this.toggleImportLayer}
            style={{ display: "flex", paddingBottom: 4, cursor: "pointer" }}
            data-mapid="clickUploadFile"
          >
            <div className="noselect" style={{ flex: 1 }}>
              {dict["Upload File"][language]}
            </div>
            <div>
              <svg
                aria-hidden="true"
                focusable="false"
                data-prefix="fas"
                data-icon="caret-down"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 320 512"
                style={{
                  width: "1.25rem",
                  height: "1.25rem",
                  transition: "transform 0.5s ease 0s",
                  transform: `${
                    modalImportLayer ? "rotate(180deg)" : "rotate(0deg)"
                  }`,
                }}
              >
                <path
                  fill="currentColor"
                  d="M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z"
                ></path>
              </svg>
            </div>
          </div>
          <ImportGeojson />
        </section>

        <section className="inputBox background_grey_light" id="api_bridging">
          <div
            onClick={this.toggleApiBridging}
            style={{ display: "flex", paddingBottom: 4, cursor: "pointer" }}
          >
            <div className="noselect" style={{ flex: 1 }}>
              {dict["Connect to API"][language]}
            </div>
            <div>
              <svg
                aria-hidden="true"
                focusable="false"
                data-prefix="fas"
                data-icon="caret-down"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 320 512"
                style={{
                  width: "1.25rem",
                  height: "1.25rem",
                  transition: "transform 0.5s ease 0s",
                  transform: `${
                    modalApiBridging ? "rotate(180deg)" : "rotate(0deg)"
                  }`,
                }}
              >
                <path
                  fill="currentColor"
                  d="M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z"
                ></path>
              </svg>
            </div>
          </div>
          <ModalApiInput />
        </section>

        <section className="inputBox background_grey_light" id="join_table">
          <div
            onClick={this.toggleJoinTable}
            style={{ display: "flex", paddingBottom: 4, cursor: "pointer" }}
            data-mapid="clickJoin"
          >
            <div className="noselect" style={{ flex: 1 }}>
              {dict["Join Table"][language]}
            </div>
            <div>
              <svg
                aria-hidden="true"
                focusable="false"
                data-prefix="fas"
                data-icon="caret-down"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 320 512"
                style={{
                  width: "1.25rem",
                  height: "1.25rem",
                  transition: "transform 0.5s ease 0s",
                  transform: `${
                    modalJoinTable ? "rotate(180deg)" : "rotate(0deg)"
                  }`,
                }}
              >
                <path
                  fill="currentColor"
                  d="M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z"
                ></path>
              </svg>
            </div>
          </div>
          <JOIN_TABLE />
        </section>

        <section
          className="inputBox background_grey_light"
          id="attach_layer"
          style={{ height: "20px" }}
        >
          <main
            className="text_collapse noselect"
            style={{ marginBottom: "10px" }}
            onClick={this.toggleAttachLayer}
          >
            <section style={{ display: "flex" }}>
              <div
                className="noselect"
                style={{ whiteSpace: "nowrap" }}
                data-mapid="clickImportData"
              >
                {dict["Attach Layer"][language]}
              </div>
            </section>
          </main>
        </section>

        <section className="inputBox background_grey_light" id="new_folder">
          <div
            onClick={this.toggleCreateFolder}
            style={{ display: "flex", paddingBottom: 4, cursor: "pointer" }}
            data-mapid="clickNewFolder"
          >
            <div className="noselect" style={{ flex: 1 }}>
              {dict["New Folder Layer"][language]}
            </div>
            <div>
              <svg
                aria-hidden="true"
                focusable="false"
                data-prefix="fas"
                data-icon="caret-down"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 320 512"
                style={{
                  width: "1.25rem",
                  height: "1.25rem",
                  transition: "transform 0.5s ease 0s",
                  transform: `${
                    modalCreateFolder ? "rotate(180deg)" : "rotate(0deg)"
                  }`,
                }}
              >
                <path
                  fill="currentColor"
                  d="M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z"
                ></path>
              </svg>
            </div>
          </div>
          <CreateFolder />
        </section>
        <hr />
      </main>
    );

    if (mode === "notif") {
      final_content = (
        <NotificationProject geo_project_link={geo_project_link} />
      );
    }

    return (
      <main>
        {modalAttachLayerContent}
        {modal_link_edit_content}
        {final_content}
      </main>
    );
  }
}

const map_state_to_props = (state) => ({
  project: state.project,
  layer: state.layer,
  auth: state.auth,
  payment: state.payment,
  properties: state.properties,
});

export default connect(map_state_to_props, {
  setTabelStatus,
  openModal,
  setModeList,
  getDetailLayerById,
  setChatStatus,
  getDetailLayerByLinkWOgeojson,
  setLanguage,
  removeDuplicateFeatures,
  setMapMode,
  set_value_layer,
  set_value_properties,
  get_detail_many_layer,
  getProjectDetailByLink,
  status_action,
})(ACTION_LAYER);
